import { io } from "socket.io-client";

// Use the same API URL as the main API service
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

let socket = null;

/**
 * Initialize Socket.io connection
 * @param {String} token - JWT token for authentication
 * @returns {Object} Socket instance
 */
export const initializeSocket = (token) => {
  if (socket && socket.connected) {
    console.log("Socket already connected");
    return socket;
  }

  // Disconnect existing socket if any
  if (socket) {
    socket.disconnect();
  }

  // Create new socket connection
  console.log("🔌 Connecting to socket server:", API_BASE_URL);
  console.log("🔌 Token provided:", token ? "Yes" : "No");

  socket = io(API_BASE_URL, {
    auth: {
      token: token,
    },
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 5,
    forceNew: true, // Force new connection
  });

  // Connection event handlers
  socket.on("connect", () => {
    console.log("✅ Socket connected successfully! Socket ID:", socket.id);
  });

  socket.on("disconnect", (reason) => {
    console.log("❌ Socket disconnected. Reason:", reason);
  });

  socket.on("connect_error", (error) => {
    console.error("❌ Socket connection error:", error.message);
    console.error("Error details:", error);
  });

  socket.on("connected", (data) => {
    console.log("✅ Socket connection confirmed by server:", data);
  });

  // Listen for authentication errors
  socket.on("error", (error) => {
    console.error("❌ Socket error:", error);
  });

  return socket;
};

/**
 * Get current socket instance
 * @returns {Object|null} Socket instance or null
 */
export const getSocket = () => {
  return socket;
};

/**
 * Disconnect socket
 */
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log("Socket disconnected and cleared");
  }
};

/**
 * Subscribe to order updates
 */
export const subscribeToOrders = () => {
  if (socket && socket.connected) {
    socket.emit("subscribe_orders");
    console.log("Subscribed to order updates");
  }
};

/**
 * Subscribe to inventory updates
 */
export const subscribeToInventory = () => {
  if (socket && socket.connected) {
    socket.emit("subscribe_inventory");
    console.log("Subscribed to inventory updates");
  }
};

/**
 * Subscribe to dashboard updates
 */
export const subscribeToDashboard = () => {
  if (socket && socket.connected) {
    socket.emit("subscribe_dashboard");
    console.log("Subscribed to dashboard updates");
  }
};

export default {
  initializeSocket,
  getSocket,
  disconnectSocket,
  subscribeToOrders,
  subscribeToInventory,
  subscribeToDashboard,
};
